module.exports = __webpack_public_path__ + "img/hollanm.585f7ee9.jpg";